import React from 'react';
import { VStack, Box, Text, Card, Button } from '@chakra-ui/react';

interface ChargeCompleteContentProps {
  chargeAmount: number;
  chargeCode: string;
  onClose: () => void;
}

export const ChargeCompleteContent: React.FC<ChargeCompleteContentProps> = ({
  chargeAmount,
  chargeCode,
  onClose,
}) => {
  return (
    <VStack gap={6} align="stretch" pb={4}>
      <VStack gap={4}>
        <Box
          borderRadius="full"
          bg="teal.100"
          w="80px"
          h="80px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize="4xl">✓</Text>
        </Box>
        <Text fontSize="lg" fontWeight="bold" color="gray.800">
          チャージが完了しました
        </Text>
      </VStack>
      <Card.Root variant="elevated" bg="teal.50" borderRadius="xl">
        <Card.Body py={6}>
          <VStack gap={2}>
            <Text fontSize="sm" color="gray.600">
              チャージ金額
            </Text>
            <Text fontSize="4xl" fontWeight="bold" color="teal.600">
              ฿{chargeAmount.toLocaleString()}
            </Text>
            <Text fontSize="xs" color="gray.500" mt={2}>
              コード: {chargeCode}
            </Text>
          </VStack>
        </Card.Body>
      </Card.Root>
      <Button colorPalette="teal" size="lg" w="full" onClick={onClose}>
        閉じる
      </Button>
    </VStack>
  );
};
